import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface StartAuditConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  surveyTitle: string;
  responseCount: number;
}

export const StartAuditConfirmDialog: React.FC<StartAuditConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  surveyTitle,
  responseCount,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmberIcon color="warning" />
          {t('audit.confirmStart.title', 'Start Audit?')}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t(
            'audit.confirmStart.message',
            'Starting the audit will close this survey and prevent further responses.'
          )}
        </Typography>
        <Box mt={2}>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('common.survey', 'Survey')}:</strong> {surveyTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('audit.currentResponses', 'Current responses')}:</strong> {responseCount}
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="body2" color="warning.main">
            {t(
              'audit.confirmStart.warning',
              'This action cannot be undone. Students who have not yet submitted their responses will no longer be able to do so.'
            )}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('audit.startAudit', 'Start Audit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
